import { Component } from '@angular/core';
import {MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-marketing-consent-dialog',
  templateUrl: './marketing-consent-dialog.component.html',
  styleUrls: ['./marketing-consent-dialog.component.scss']
})
export class MarketingConsentDialogComponent {
  constructor(private dialogRef: MatDialogRef<MarketingConsentDialogComponent>) {}

  onAccept() {
    this.dialogRef.close(true); // felhasználó mégis szeretne marketing e-mailt
  }

  onDecline() {
    this.dialogRef.close(false); // felhasználó nem szeretne
  }
}
